import React from 'react';
import PropTypes from 'prop-types';

import Booking from 'models/booking';

import PullTicket from 'components/svgs/icons/pull-ticket';

const propTypes = {
  booking: PropTypes.instanceOf(Booking).isRequired,
};

const ViewReceipt = ({ booking }) => {
  if (booking.onDemand) { return null; }

  return (
    <a href={`${booking.anonymousReceiptUrl}`} className="deco-link text-size-12 align-right">
      <PullTicket />
      <span>View Receipt</span>
    </a>
  );
};

ViewReceipt.propTypes = propTypes;
export default ViewReceipt;
